import { combineReducers } from 'redux';

import { ILayoutState, layoutReducer } from './layout';

// Top-level state
export interface IApplicationState {
  layout: ILayoutState;
}

export const createRootReducer = () => {
  return combineReducers({
    layout: layoutReducer,
  });
};
